import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { getBeisenUser } from '@/utils/beisen';
import { inject, injectable } from 'inversify';
import _ from 'lodash';
let DataMigrationService = class DataMigrationService {
    constructor(workspaceApi, i18n, accountApi) {
        this.workspaceApi = workspaceApi;
        this.i18n = i18n;
        this.accountApi = accountApi;
        this.getSpaceOfUser = this.workspaceApi.getSpaceOfUser;
        this.transfer = this.workspaceApi.transfer;
    }
    async getTransferHistory(params) {
        const res = await this.workspaceApi.getTransferHistory(params);
        const records = _.get(res, 'data.records', []);
        const emails = _.uniq(_.reduce(records, (sum, n) => {
            if (n.operator_email) {
                sum.push(n.operator_email);
            }
            return sum;
        }, []));
        if (emails.length) {
            // emails 请求映射关系
            const infoList = await this.accountApi.postBeisenAccountByEmails(emails);
            const infoMaps = _.groupBy(infoList, 'email');
            _.forEach(records, (el) => {
                const item = _.get(infoMaps[el.operator_email], '[0]', {});
                el.operator_email = getBeisenUser({
                    defaultName: el.operator_email,
                    departmentName: item.department_name,
                    employeeName: item.employee_name,
                });
            });
        }
        return res;
    }
    statusTxt(code) {
        switch (code) {
            case '000':
            case '408':
                return this.i18n.t('workspace.dataMigration.statusWait');
            case '100':
            case '501':
            case '502':
            case '503':
                return this.i18n.t('workspace.dataMigration.statusError');
            case '200':
            case '201':
                return this.i18n.t('workspace.dataMigration.statusComplete');
            case '300':
                return this.i18n.t('workspace.dataMigration.statusProcess');
        }
    }
};
DataMigrationService = __decorate([
    injectable(),
    __param(0, inject(Symbols.WorkspaceApi)),
    __param(1, inject(Symbols.I18n)),
    __param(2, inject(Symbols.AccountApi)),
    __metadata("design:paramtypes", [Object, Object, Object])
], DataMigrationService);
export { DataMigrationService };
